import React, { Component } from "react"
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { logoutUser, saveLogoutTime  } from "../../store/actions"
import api from "../../api";

class Logout extends Component {
  /**
   * Redirect to login
   */
componentDidMount = async () => {
  let userInfo = null;

  const user = localStorage.getItem("user_info");

  if (user && user !== "undefined" && user !== "null") {
    try {
      userInfo = JSON.parse(user);
    } catch (err) {
      console.error("Invalid user_info in localStorage", err);
    }
  }

  if (userInfo) {
    await api({
      method: "post",
      data: userInfo,
      url: `${process.env.REACT_APP_API_URL}/admin/auth/saveLogoutTime`,
    });
  }
   // 🔥 CLEAR ONLY REQUIRED KEYS
    [
      "roleWiseAccess",
      "authUser",
      "user_info",
      "token",
    ].forEach(key => localStorage.removeItem(key));
  this.props.logoutUser(this.props.history);
};


  render() {
    return <React.Fragment></React.Fragment>
  }
}

Logout.propTypes = {
  history: PropTypes.any,
  logoutUser: PropTypes.func
}

export default withRouter(connect(null, { logoutUser })(Logout))
